export var TeamMemberSubSkillLGSF;
(function (TeamMemberSubSkillLGSF) {
    TeamMemberSubSkillLGSF["ExistingCustomer"] = "EXISTING_CUSTOMER";
    TeamMemberSubSkillLGSF["SlrToHls"] = "SLR_TO_HLS";
    TeamMemberSubSkillLGSF["HighValue"] = "HIGH_VALUE";
    TeamMemberSubSkillLGSF["ComplexInvestment"] = "COMPLEX_INVESTMENT";
    TeamMemberSubSkillLGSF["LoanAmountUnder200k"] = "LOAN_AMOUNT_UNDER_200K";
    TeamMemberSubSkillLGSF["TestGroupA"] = "TEST_GROUP_A";
    TeamMemberSubSkillLGSF["TestGroupB"] = "TEST_GROUP_B";
    TeamMemberSubSkillLGSF["PurchaseExploringOptions"] = "PURCHASE_EXPLORING_OPTIONS";
})(TeamMemberSubSkillLGSF || (TeamMemberSubSkillLGSF = {}));
export var TeamMemberSubSkillLGSFWithLabel = {
    ExistingCustomer: {
        value: 'EXISTING_CUSTOMER',
        label: 'Existing Customer',
    },
    SlrToHls: {
        value: 'SLR_TO_HLS',
        label: 'SLR to HLS',
    },
    HighValue: {
        value: 'HIGH_VALUE',
        label: 'High Value',
    },
    ComplexInvestment: {
        value: 'COMPLEX_INVESTMENT',
        label: 'Complex Investment',
    },
    LoanAmountUnder200k: {
        value: 'LOAN_AMOUNT_UNDER_200K',
        label: 'Loan amount under 200k',
    },
    TestGroupA: {
        value: 'TEST_GROUP_A',
        label: 'Test Group A',
    },
    TestGroupB: {
        value: 'TEST_GROUP_B',
        label: 'Test Group B',
    },
    PurchaseExploringOptions: {
        value: 'PURCHASE_EXPLORING_OPTIONS',
        label: 'Purchase Exploring Options',
    },
};
//# sourceMappingURL=TeamMemberSubSkillLGSF.js.map